import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ["input", "termHeaders", "termRows", "userSubmitTermForm"];

  onSearchInput() {
    const userInput = this.inputTarget.value;
    this.showTermsSearchResults(userInput)
    this.showUserTermSubmitForm()
  }

  redirectTermShowPage(e) {
    window.location.href = `/glossary/${e.currentTarget.dataset["termIdentifier"]}`
  }

  findMatchingTerms(userInput) {
     this.termRowsTargets.forEach(function(termRow){
       var termRowName = termRow.dataset["termName"].toLowerCase()
       var userInputLowerCase = userInput.toLowerCase()
       if(!termRowName.includes(userInputLowerCase)){
         this.hideAll([termRow])
       } else{
         this.showAll([termRow])
       }
     }, this);
   }

  showTermsSearchResults(userInput) {
     if(this.inputTarget.value == ""){
       this.showAll(this.termHeadersTargets)
       this.showAll(this.termRowsTargets)
     } else {
       this.hideAll(this.termHeadersTargets)
       this.findMatchingTerms(userInput)
     }
   }

   showUserTermSubmitForm() {
     let matchingTerms = []
     this.termRowsTargets.forEach(function(element){
        if(!element.classList.contains('d-none')){
          matchingTerms.push(element)
        }
     });

     if(matchingTerms.length == 0) {
       this.userSubmitTermFormTarget.classList.remove('d-none')
     } else {
       this.userSubmitTermFormTarget.classList.add('d-none')
     }
   }

  hideAll(elements) {
     elements.forEach(function(element){
       element.classList.add('d-none')
      });
   }

  showAll(elements) {
     elements.forEach(function(element){
       element.classList.remove('d-none')
      });
   }
}
